module.exports = __webpack_public_path__ + "static/media/Coin_Icon@3x.1475c935.png";